import { useEffect, useState } from "react";
import { _baseRequest } from "../../../utils/baseApi";

export const SkillRating = ({ job }: any) => {
  const [loadingStates, setLoadingStates] = useState<Record<string, boolean>>(
    {}
  );
  const [userId, setUserId] = useState(null);
  const userDetailsData = localStorage.getItem("jobByHiringTeamMembers");
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];

 

  useEffect(() => {
    const storedUserDetails = JSON.parse(
      localStorage.getItem("userDetails") || "{}"
    );
    setUserId(storedUserDetails?.id); // Assuming the user ID is stored as 'id' in userDetails
  }, []);

  const hasUserRated = (userIds: any, currentUserId: any) => {
    if (!userIds || !currentUserId) {
      return false;
    }

    const userIdArray = userIds
      .toString()
      .split(",")
      .map((id: any) => id.trim());
    return userIdArray.includes(currentUserId.toString());
  };

  const getBackgroundClasses = (
    userIds: any,
    currentUserId: any,
    ratingType: any
  ) => {
    const hasRated = hasUserRated(userIds, currentUserId);

    if (!hasRated) {
      return "bg-gray-50 ring-1 ring-inset ring-gray-500/10 text-gray-600";
    }

    // Different colors based on rating type
    switch (ratingType) {
      case "yes":
        return "bg-[#f0fdf4] border-green-200 text-[#008236] ring-green-600/20 ring-1 ring-inset";
      case "maybe":
        return "bg-[#fefce8] border-yellow-200 text-[#894b00] ring-yellow-600/20 ring-1 ring-inset";
      case "no":
        return "bg-[#fef2f2] border-red-200 text-[#c10007] ring-red-600/20 ring-1 ring-inset";
      default:
        return "bg-[#fbf9fa] border-gray-200 text-[#4a5565] ring-gray-600/20 ring-1 ring-inset";
    }
  };

  const getAllUserImages = (userIds: any) => {
    if (!userIds) return [];

    const userIdArray = userIds
      .toString()
      .split(",")
      .map((id: any) => Number(id.trim()));

    return userIdArray.map((userId: any) => {
      const user = baseMembers.find(
        (member: any) =>
          member.user_id === userId || member.user_id === Number(userId)
      );
      return {
        id: userId,
        name: user ? user.name : `AI`,
        profile_pic: user ? user.profile_pic : null,
        isAI: !user,
      };
    });
  };

  const getJobLoading = (jobId: any, buttonType: any) => {
    return loadingStates[`${jobId}_${buttonType}`] || false;
  };

  const reviewMaybe = getAllUserImages(job?.maybe_user_ids);
  const reviewYes = getAllUserImages(job?.yes_user_ids);
  const reviewNo = getAllUserImages(job?.no_user_ids);

  // Get individual loading states for this specific job
  const isYesLoading = getJobLoading(job.id, "yes");
  const isMaybeLoading = getJobLoading(job.id, "maybe");
  const isNoLoading = getJobLoading(job.id, "no");


  return (
    <div className="rounded-md  cursor-pointer  feedback-delete-hover">
      <div className="flex items-center gap-2">
        {job?.yes_user_ids && 
        <div className="flex items-center gap-2 mt-2">
          <div className="flex items-center gap-2">
            <span
              //   onClick={() => !isYesLoading && handleAddRating(job)}
              className={`flex cursor-pointer items-center gap-[6px] text-[13px] capitalize rounded-md px-2 py-1 
                                                          text-xs font-medium ${getBackgroundClasses(
                                                            job?.yes_user_ids,
                                                            userId,
                                                            "yes"
                                                          )}`}
            >
              {isYesLoading ? (
                <>
                  <svg
                    className="animate-spin h-3 w-3 mr-1"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Yes
                </>
              ) : (
                "Yes"
              )}
              {!isYesLoading && (
                <>
                  {job?.yes_rating_count > 0 && (
                    <>
                      <span className="mx-[2px] w-[1px] h-[12px] bg-gray-400 block"></span>
                      <span className="text-xs font-medium text-gray-700">
                        {job?.yes_rating_count}
                      </span>
                    </>
                  )}

                  {job?.yes_user_ids && (
                    <>
                      <span className="mx-[2px] w-[1px] h-[12px] bg-gray-400 block"></span>

                      {reviewYes.map((item: any, index: any) => {
                        return (
                          <div key={index}>
                            {item?.isAI ? (
                              // Show SVG for AI
                              <span
                                className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                data-title="AI"
                              >
                                <span className="h-4 w-4 flex items-center justify-center rounded-full ring-1 ring-[#ffeab6] bg-[#ffeab6]">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="w-[12px] h-[12px] text-yellow-700"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                                    />
                                  </svg>
                                </span>
                              </span>
                            ) : item?.profile_pic ? (
                              <span
                                className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                data-title={item?.name}
                              >
                                <img
                                  src={`${process.env.REACT_APP_API_BASE_URL}/${item?.profile_pic}`}
                                  alt={`${"Profile"}`}
                                  className="h-4 w-4 min-w-[1rem] min-h-[1rem] shrink-0 rounded-full object-cover ring-1 ring-gray-900/10"
                                />
                              </span>
                            ) : (
                              <span
                                className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                data-title={item?.name}
                              >
                                <span
                                  className="bg-[#a3a3a3] flex items-center justify-center h-4 w-4 flex-none rounded-full ring-1
                                                                 ring-gray-900/10 text-white text-[10px] font-medium capitalize line-clamp-1"
                                >
                                  {item?.name?.charAt(0).toUpperCase()}
                                </span>
                              </span>
                            )}
                          </div>
                        );
                      })}
                    </>
                  )}
                </>
              )}
            </span>
          </div>
        </div>}
        

        {/*  maybe */}

       {job?.maybe_user_ids && 
       <div className="flex items-center gap-2 mt-2">
          <div className="flex items-center gap-2">
            <span
              //   onClick={() => !isMaybeLoading && handleAddRatingMaybe(job)}
              className={`flex cursor-pointer items-center gap-[6px] text-[13px] capitalize rounded-md px-2 py-1 
                                                          text-xs font-medium ${getBackgroundClasses(
                                                            job?.maybe_user_ids,
                                                            userId,
                                                            "maybe"
                                                          )}`}
            >
              {isMaybeLoading ? (
                <>
                  <svg
                    className="animate-spin h-3 w-3 mr-1"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Maybe
                </>
              ) : (
                "Maybe"
              )}
              {!isMaybeLoading && (
                <>
                  {job?.maybe_rating_count > 0 && (
                    <>
                      <span className="mx-[2px] w-[1px] h-[12px] bg-gray-400 block"></span>
                      <span className="text-xs font-medium text-gray-700">
                        {job?.maybe_rating_count}
                      </span>
                    </>
                  )}

                  {job?.maybe_user_ids && (
                    <>
                      <span className="mx-[2px] w-[1px] h-[12px] bg-gray-400 block"></span>
                      {reviewMaybe.map((item: any, index: any) => (
                        <div key={index}>
                          {item?.isAI ? (
                            // Show SVG for AI
                            <span
                              className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                              data-title="AI"
                            >
                              <span className="h-4 w-4 flex items-center justify-center rounded-full ring-1 ring-[#ffeab6] bg-[#ffeab6]">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  strokeWidth="1.5"
                                  stroke="currentColor"
                                  className="w-[12px] h-[12px] text-yellow-700"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                                  />
                                </svg>
                              </span>
                            </span>
                          ) : item?.profile_pic ? (
                            <span
                              className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                              data-title={item?.name}
                            >
                              <img
                                src={`${process.env.REACT_APP_API_BASE_URL}/${item.profile_pic}`}
                                alt="Profile"
                                className="h-4 w-4 min-w-[1rem] min-h-[1rem] shrink-0 rounded-full object-cover ring-1 ring-gray-900/10"
                              />
                            </span>
                          ) : (
                            <span
                              className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                              data-title={item?.name}
                            >
                              <span className="bg-[#a3a3a3] flex items-center justify-center h-4 w-4 flex-none rounded-full ring-1 ring-gray-900/10 text-white text-[10px] font-medium capitalize">
                                {item?.name?.charAt(0).toUpperCase()}
                              </span>
                            </span>
                          )}
                        </div>
                      ))}
                    </>
                  )}
                </>
              )}
            </span>
          </div>
        </div>}


        {/*  no */}

        {job?.no_user_ids && <div className="flex items-center gap-2 mt-2">
          <div className="flex items-center gap-2">
            <span
              //   onClick={() => !isNoLoading && handleAddRatingNo(job)}
              className={`flex cursor-pointer items-center gap-[6px] text-[13px] capitalize rounded-md px-2 py-1 
                                                     text-xs font-medium ${getBackgroundClasses(
                                                       job?.no_user_ids,
                                                       userId,
                                                       "no"
                                                     )}`}
            >
              {isNoLoading ? (
                <>
                  <svg
                    className="animate-spin h-3 w-3 mr-1"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  No
                </>
              ) : (
                "No"
              )}
              {!isNoLoading && (
                <>
                  {job?.no_rating_count > 0 && (
                    <>
                      <span className="mx-[2px] w-[1px] h-[12px] bg-gray-400 block"></span>
                      <span className="text-xs font-medium text-gray-700">
                        {job?.no_rating_count}
                      </span>
                    </>
                  )}

                  {job?.no_user_ids && (
                    <>
                      <span className="mx-[2px] w-[1px] h-[12px] bg-gray-400 block"></span>

                      {reviewNo.map((item: any, index: any) => {
                        return (
                          <div key={index}>
                            {item?.isAI ? (
                              // Show SVG for AI
                              <span
                                className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                data-title="AI"
                              >
                                <span className="h-4 w-4 flex items-center justify-center rounded-full ring-1 ring-[#ffeab6] bg-[#ffeab6]">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="w-[12px] h-[12px] text-yellow-700"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                                    />
                                  </svg>
                                </span>
                              </span>
                            ) : item?.profile_pic ? (
                              <span
                                className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                data-title={item?.name}
                              >
                                <img
                                  src={`${process.env.REACT_APP_API_BASE_URL}/${item?.profile_pic}`}
                                  alt={`${"Profile"}`}
                                  className="h-4 w-4 min-w-[1rem] min-h-[1rem] shrink-0 rounded-full object-cover ring-1 ring-gray-900/10"
                                />
                              </span>
                            ) : (
                              <span
                                className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                data-title={item?.name}
                              >
                                <span
                                  className="bg-[#a3a3a3] flex items-center justify-center h-4 w-4 flex-none rounded-full ring-1
                                                                 ring-gray-900/10 text-white text-[10px] font-medium capitalize line-clamp-1"
                                >
                                  {item?.name?.charAt(0).toUpperCase()}
                                </span>
                              </span>
                            )}
                          </div>
                        );
                      })}
                    </>
                  )}
                </>
              )}
            </span>
          </div>
        </div>
}
      </div>
    </div>
  );
};
